import { createEntityAdapter, EntityAdapter } from '@locumsnest/core/src/lib/ngrx/cached-state';

import { IHospitalSpecialtyEntity } from '../../interfaces/api/hospital-specialty-entity';
import { IHospitalSpecialtyEntityState } from './interfaces';

export const adapter: EntityAdapter<IHospitalSpecialtyEntity> =
  createEntityAdapter<IHospitalSpecialtyEntity>({});

export const initialState = adapter.getInitialState<IHospitalSpecialtyEntityState>({
  // additional entity state properties
  selectedHospitalSpecialtyId: null,
});
